/* ───────────────────────────────────────────────────────────
   Dipped Order page — interactive form behavior
   - +/- qty controls with per-section running totals
   - Compile selected items into hidden contact[] fields
     so they appear in the inquiry email Shopify sends
   - Native form submit (no preventDefault) so Shopify routes
     the post to /contact and emails the shop owner
   ─────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var form = document.getElementById('orderForm');
    if (!form) return;

    // ─── Quantity selectors ───
    function updateSectionTotal(name) {
      var rows = form.querySelectorAll('.qty-row[data-name="' + name + '"]');
      var total = 0;
      rows.forEach(function (row) {
        var v = parseInt(row.querySelector('input[type="hidden"]').value, 10) || 0;
        total += v;
      });
      var meta = form.querySelector('[data-total="' + name + '"]');
      if (meta) meta.textContent = total;
    }

    function setQty(row, qty) {
      qty = Math.max(0, qty | 0);
      var hidden = row.querySelector('input[type="hidden"]');
      var numEl = row.querySelector('.qty-val .num');
      var minusBtn = row.querySelector('.qty-minus');
      hidden.value = qty;
      numEl.textContent = qty;
      if (qty > 0) row.classList.add('active'); else row.classList.remove('active');
      minusBtn.disabled = (qty === 0);
      updateSectionTotal(row.getAttribute('data-name'));
    }

    form.querySelectorAll('.qty-row').forEach(function (row) {
      var hidden = row.querySelector('input[type="hidden"]');
      setQty(row, parseInt(hidden.value, 10) || 0);
      row.querySelector('.qty-plus').addEventListener('click', function () {
        var current = parseInt(hidden.value, 10) || 0;
        var min = parseInt(row.getAttribute('data-min'), 10) || 0;
        if (current === 0 && min > 1) {
          setQty(row, min);
        } else {
          setQty(row, current + 1);
        }
      });
      row.querySelector('.qty-minus').addEventListener('click', function () {
        var current = parseInt(hidden.value, 10) || 0;
        var min = parseInt(row.getAttribute('data-min'), 10) || 0;
        if (min > 1 && current === min) {
          setQty(row, 0);
        } else {
          setQty(row, current - 1);
        }
      });
    });

    // ─── Compile email-friendly summaries on submit ───
    // For each qty section, build "Item name × N DZ" lines and put
    // them into a hidden contact[<Section>] field. For checkbox
    // groups, build a comma-separated list.
    function compileQtySummary(name) {
      var lines = [];
      form.querySelectorAll('.qty-row[data-name="' + name + '"]').forEach(function (row) {
        var v = parseInt(row.querySelector('input[type="hidden"]').value, 10) || 0;
        if (v > 0) {
          var label = row.querySelector('.qty-label').childNodes[0].textContent.trim();
          lines.push(label + ' × ' + v + ' DZ');
        }
      });
      return lines.join('\n');
    }

    function compileCheckSummary(name) {
      var labels = [];
      form.querySelectorAll('input[name="' + name + '"]:checked').forEach(function (input) {
        var row = input.closest('label');
        var labelText = row ? (row.querySelector('.label-text') ? row.querySelector('.label-text').childNodes[0].textContent.trim() : input.value) : input.value;
        labels.push(labelText);
      });
      return labels.join(', ');
    }

    function setHidden(name, value) {
      var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      el.value = value || '';
    }

    form.addEventListener('submit', function () {
      // Build readable summaries for the email
      setHidden('contact[Treats]', compileQtySummary('treat'));
      setHidden('contact[Cake pop shapes]', compileQtySummary('shape'));
      setHidden('contact[Cake flavors]', compileQtySummary('flavor'));
      setHidden('contact[Add-ons]', compileQtySummary('addon'));
      setHidden('contact[Acrylic sticks]', compileQtySummary('stick'));
      setHidden('contact[Decorative elements]', compileCheckSummary('decor'));
      // Native browser validation handles required fields; do not
      // preventDefault — let Shopify route to /contact normally.
    });
  }
})();
